<svelte:options immutable={true} />

<script lang="ts">
  import { onMount, createEventDispatcher } from "svelte";
  import { clickOutside } from "./utils/clickOutside.js";
  import AssignStaffEditor from "./components/other/AssignStaffEditor.svelte";
  export let items;
  export let type;
  export let placeholder;
  export let merusToken;
  export let fluentCaseToken;
  export let appId;
  export let user;
  export let merusCaseEnabled;
  export let fluentCaseEnabled;
  export let emailSubject = "";
  export let emailCC;
  export let friends;
  export let selectedChatUser;
  export let checkIfEmailExternal;
  let searchKey = "";
  let selectedItem: any = "";
  let displayDropdown = false;
  let noEmailUser;
  let addEmailPanel = false;
  let newEmail;
  let checkIfEmail;
  let searchCount = 0;
  let newPanel = false;
  let merusPanel = false;
  let fluentCasePanel = false;
  let name = "";
  let email = "";
  let phone = "";
  let attorney_responsible = "";
  let attorney_handling = "";
  let paralegal_handling = "";
  let secretary_handling = "";
  let senior_associate_handling = "";
  let hearing_rep = "";
  let attorney_4 = "";
  let staff_4 = "";
  let casefileLink = "";
  let matterLink = "";
  let casefileId = "";
  let matterId = "";
  let showCaseFileSelection = false;
  let showMatterSelection = false;
  let selectedCaseFileId = "";
  let selectedMatterId = "";
  let pendingItem = null;
  let casefileNameMap = new Map(); // Map to store casefile ID to name
  let matterNameMap = new Map(); // Map to store matter ID to name
  let casefileNames = []; // Array to hold casefile names for the dropdown
  let matterNames = []; // Array to hold matter names for the dropdown
  let isLoadingNames = false; // Track loading state
  let ccDropdownOpen = false; // Track CC dropdown state
  let assignedStaffIds: string[] = []; // Staff assigned to the conversation in share flow
  let initialAssignedStaffIds: string[] = [];
  /** Source-matter emails that are not LegalPal team members (display-only + badge). */
  let externalStaffEmails: string[] = [];
  /** Bumps when user edits staff so in-flight Fluent/Merus enrich cannot overwrite. */
  let assignedStaffEditGen = 0;
  let staffAssignSaving = false;
  let awaitingSaveToContinue = false; // Must Save to Continue before signature/share UI
  let fetchPromptSource = ""; // 'merus' | 'fluent' | 'new' | 'existing'
  let emailFieldError = "";
  let saveIndicator = {
    show: false,
    message: "",
    type: "success" // "success" | "error"
  }; // Save indicator state
  let isSaving = false; // Track saving state for buttons
  const dispatch = createEventDispatcher();

  const STAFF_EMAIL_FIELDS = [
    "attorney_responsible",
    "attorney_handling",
    "paralegal_handling",
    "secretary_handling",
    "senior_associate_handling",
    "hearing_rep",
    "attorney_4",
    "staff_4",
  ];

  $: teamFriends = Array.isArray(friends) ? friends : [];
  $: availableStaffToAdd = teamFriends.filter((f) => f?.id && !assignedStaffIds.includes(f.id));
  // Team assignees + orphans + non-team source emails (Fluent/Merus)
  $: assignedStaffMembers = (() => {
    const fromTeam = teamFriends.filter((f) => assignedStaffIds.includes(f.id));
    const knownIds = new Set(fromTeam.map((f) => f.id));
    const orphans = assignedStaffIds
      .filter((id) => !knownIds.has(id))
      .map((id) => ({ id, email: id, name: id, isTeamMember: false, external: true }));
    const external = externalStaffEmails.map((email) => ({
      id: `ext:${email}`,
      email,
      name: email,
      isTeamMember: false,
      external: true,
    }));
    return [...fromTeam.map((f) => ({ ...f, isTeamMember: true, external: false })), ...orphans, ...external];
  })();

  // Reactive CC array for proper UI updates
  $: ccArray = (() => {
    if (!emailCC) return [];
    if (Array.isArray(emailCC)) return emailCC;
    if (typeof emailCC === 'string') {
      return emailCC.split(',').map(e => e.trim()).filter(e => e);
    }
    return [];
  })();

  // Show save indicator with auto-hide
  function showSaveIndicator(message, type = "success") {
    saveIndicator = { show: true, message, type };
    setTimeout(() => {
      saveIndicator.show = false;
    }, 3000); // Auto-hide after 3 seconds
  }

  function formatPhoneDisplay(phoneValue) {
    const raw = String(phoneValue ?? '').trim();
    if (!raw) return '';
    return raw.startsWith('+') ? raw : `+${raw}`;
  }

  // Helper function to get unique casefiles by ID
  function getUniqueCasefiles(casefiles) {
    const seen = new Set();
    return casefiles.filter(cf => {
      if (seen.has(cf.id)) return false;
      seen.add(cf.id);
      return true;
    });
  }

  // Helper function to get unique matters by ID
  function getUniqueMatters(matters) {
    const seen = new Set();
    return matters.filter(m => {
      if (seen.has(m.id)) return false;
      seen.add(m.id);
      return true;
    });
  }

  async function render() {
    addEmailPanel = false;
    noEmailUser = "";
  }
  function onSelectKey() {
    if (type == "email") {
      //dispatch("enterEmail", { item: { email: searchKey, id: "" } });
    }
  }
  async function onSelect(item, options: { requireSaveContinue?: boolean; promptSource?: string } = {}) {
    console.log("item", item);
    selectedItem = item;
    // matterId = getMatterId(item);
    searchCount = 0;
    const requireSaveContinue = options.requireSaveContinue !== false;
    
    // Check if we need to show ID selection panels
    let hasMultipleCaseFiles = false;
    let hasMultipleMatters = false;
    
    if (merusCaseEnabled && item.advanced && item.advanced.caseFileIds && item.advanced.caseFileIds.length > 1) {
      hasMultipleCaseFiles = true;
    }
    
    if (fluentCaseEnabled && item.fluentCaseMattersIds && item.fluentCaseMattersIds.length > 1) {
      hasMultipleMatters = true;
    }
    
    // If there are multiple IDs, show selection panels
    if (hasMultipleCaseFiles || hasMultipleMatters) {
      pendingItem = item;
      isLoadingNames = true;
      
      // Reset arrays
      casefileNames = [];
      matterNames = [];
      
      if (hasMultipleCaseFiles) {
        showCaseFileSelection = true;
        selectedCaseFileId = item.advanced.caseFileIds[0]; // Default to first
        // Fetch all casefile names
        await fetchAllCasefileNames(item.advanced.caseFileIds);
      }
      if (hasMultipleMatters) {
        showMatterSelection = true;
        selectedMatterId = item.fluentCaseMattersIds[0]; // Default to first
        // Fetch all matter names
        await fetchAllMatterNames(item.fluentCaseMattersIds);
      }
      
      isLoadingNames = false;
      return false; // Don't proceed with selection yet
    }
    
    if (type == "email" || type == "case") {
      if (item.email == "") {
        addEmailPanel = true;
        noEmailUser = item;
        return false;
      }
      searchKey = item.email;
    } else {
      searchKey = item.fullName;
    }
    // Dropdown/list payloads often omit assignedTo — refresh from server before applying Fluent defaults.
    item = await refreshAssignedToFromServer(item);
    selectedItem = item;
    loadAssignedStaffFromConversation(item);
    await enrichAssignedStaffFromMatterSources(item);
    newPanel = false;
    merusPanel = false;
    fluentCasePanel = false;
    awaitingSaveToContinue = requireSaveContinue;
    fetchPromptSource = requireSaveContinue
      ? (options.promptSource || "existing")
      : "";
    dispatch("select", { item });
  }
  function onDelete() {
    dispatch("delete");
  }
  
  function createModifiedUser(originalUser, selectedCaseFileId, selectedMatterId) {
    // Create a deep copy of the original user
    const modifiedUser = JSON.parse(JSON.stringify(originalUser));
    
    // Update with selected IDs only
    if (selectedCaseFileId && modifiedUser.advanced && modifiedUser.advanced.caseFileIds) {
      modifiedUser.advanced.caseFileIds = [selectedCaseFileId];
    }
    
    if (selectedMatterId && modifiedUser.fluentCaseMattersIds) {
      modifiedUser.fluentCaseMattersIds = [selectedMatterId];
    }
    
    return modifiedUser;
  }

  async function confirmIdSelection() {
    if (pendingItem) {
      // Update the pending item with selected IDs
      if (showCaseFileSelection && selectedCaseFileId) {
        casefileId = selectedCaseFileId;
      }
      if (showMatterSelection && selectedMatterId) {
        matterId = selectedMatterId;
      }
      
      // Reset selection panels
      showCaseFileSelection = false;
      showMatterSelection = false;
      selectedCaseFileId = "";
      selectedMatterId = "";
      
      // Proceed with the original selection
      let item = pendingItem;
      pendingItem = null;
      
      if (type == "email" || type == "case") {
        if (item.email == "") {
          addEmailPanel = true;
          noEmailUser = item;
          return false;
        }
        searchKey = item.email;
      } else {
        searchKey = item.fullName;
      }
      item = await refreshAssignedToFromServer(item);
      loadAssignedStaffFromConversation(item);
      await enrichAssignedStaffFromMatterSources(item, {
        caseFileId: casefileId || selectedCaseFileId,
        matterId: matterId || selectedMatterId,
      });
      newPanel = false;
      merusPanel = false;
      fluentCasePanel = false;
      awaitingSaveToContinue = true;
      fetchPromptSource = "existing";
      dispatch("select", { item });
    }
  }
  
  function cancelIdSelection() {
    showCaseFileSelection = false;
    showMatterSelection = false;
    selectedCaseFileId = "";
    selectedMatterId = "";
    pendingItem = null;
    casefileNames = [];
    matterNames = [];
    isLoadingNames = false;
  }
  
  async function fetchCasefileName(casefileId) {
    if (!casefileId || casefileNameMap.has(casefileId)) {
      return casefileNameMap.get(casefileId) || casefileId;
    }
    try {
      const jwtToken = localStorage.getItem("token");
      if (jwtToken) {
        const response = await fetch(`https://api.qix.cloud/caseFiles/${casefileId}/name`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + jwtToken,
            "Content-Type": "application/json",
          },
        });
        if (response.ok) {
          const data = await response.json();
          // Handle different response formats
          let name = casefileId;
          if (typeof data === 'string') {
            name = data;
          } else if (data && data.name) {
            name = data.name;
          } else if (data && typeof data === 'object') {
            // Try to extract name from various properties
            name = data.title || data.label || JSON.stringify(data);
          }
          casefileNameMap.set(casefileId, name);
          return name;
        }
      }
    } catch (error) {
      console.error("Error fetching casefile name:", error);
    }
    return casefileId;
  }
  
  async function fetchMatterName(matterId) {
    if (!matterId || matterNameMap.has(matterId)) {
      return matterNameMap.get(matterId) || matterId;
    }
    try {
      const jwtToken = localStorage.getItem("token");
      if (jwtToken) {
        const response = await fetch(`https://api.qix.cloud/fluentCase/${matterId}/name`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + jwtToken,
            "Content-Type": "application/json",
          },
        });
        if (response.ok) {
          const data = await response.json();
          // Handle different response formats
          let name = matterId;
          if (typeof data === 'string') {
            name = data;
          } else if (data && data.name) {
            name = data.name;
          } else if (data && typeof data === 'object') {
            // Try to extract name from various properties
            name = data.title || data.label || JSON.stringify(data);
          }
          matterNameMap.set(matterId, name);
          return name;
        }
      }
    } catch (error) {
      console.error("Error fetching matter name:", error);
    }
    return matterId;
  }
  
  async function fetchAllCasefileNames(casefileIds) {
    const names = [];
    for (const id of casefileIds) {
      const name = await fetchCasefileName(id);
      names.push({ id, name });
    }
    casefileNames = names; // Reassign to trigger reactivity
  }
  
  async function fetchAllMatterNames(matterIds) {
    const names = [];
    for (const id of matterIds) {
      const name = await fetchMatterName(id);
      names.push({ id, name });
    }
    matterNames = names; // Reassign to trigger reactivity
  }
  
  function displayDropdownFunc() {
    displayDropdown = !displayDropdown;
  }
  function hideDropdownFunc() {
    displayDropdown = false;
  }

  // Multi-select CC functions
  function toggleCCDropdown() {
    ccDropdownOpen = !ccDropdownOpen;
  }

  function toggleFriendCC(friendEmail) {
    if (ccArray.includes(friendEmail)) {
      // Remove from selection
      emailCC = ccArray.filter(e => e !== friendEmail).join(', ');
    } else {
      // Add to selection
      emailCC = [...ccArray, friendEmail].join(', ');
    }
  }

  function normalizeEmailCC() {
    if (!emailCC) return "";
    if (Array.isArray(emailCC)) {
      return emailCC.filter(e => e && e.trim()).join(', ');
    }
    if (typeof emailCC === 'string') {
      return emailCC;
    }
    return "";
  }
  function getMatterId(item) {
    if (!item.tags) return null; // Ensure 'tags' exists

    const matterTag = item.tags.find(tag => tag.name === "matterId");
    return matterTag ? matterTag.id : "";
}
  async function updateSelectedUser() {
    if (newEmail != "") {
      const regexExp =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

      checkIfEmail = regexExp.test(newEmail);
      if (checkIfEmail) {
        noEmailUser.email = newEmail;
        console.log("noEmailUser", noEmailUser);
        const jwtToken = localStorage.getItem("token");
        if (jwtToken != null) {
          await fetch("https://api.qix.cloud/conversation", {
            method: "PUT",
            body: JSON.stringify(noEmailUser),
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + jwtToken,
            },
          });
          addEmailPanel = false;
          onSelect(noEmailUser);
          noEmailUser = "";
        }
      }
    }
  }
  function incrementSearchCount() {
    searchCount++;
    //console.log("searchCount", searchCount);
    return true; // allows the condition to continue
  }
  function initSearchCount() {
    searchCount = 0;
    console.log("searchCount", searchCount);
  }
  function loadAssignedStaffFromConversation(item) {
    assignedStaffEditGen += 1;
    const ids = Array.isArray(item?.assignedTo) ? item.assignedTo.filter(Boolean) : [];
    assignedStaffIds = [...new Set(ids)];
    initialAssignedStaffIds = [...assignedStaffIds];
    externalStaffEmails = [];
    staffAssignSaving = false;
  }

  function conversationHasSavedAssignedStaff(item) {
    return Array.isArray(item?.assignedTo) && item.assignedTo.filter(Boolean).length > 0;
  }

  /** List rows often omit assignedTo — load the real list from GET /chat/:id. */
  async function refreshAssignedToFromServer(item) {
    if (!item?.id) return item;
    const jwtToken = localStorage.getItem("token");
    if (!jwtToken) return item;
    try {
      const res = await fetch(`https://api.qix.cloud/chat/${encodeURIComponent(item.id)}`, {
        method: "GET",
        headers: { Authorization: "Bearer " + jwtToken },
      });
      if (!res.ok) return item;
      const chat = await res.json();
      const assignedTo = Array.isArray(chat?.assignedTo) ? chat.assignedTo.filter(Boolean) : [];
      const next = { ...item, assignedTo: [...assignedTo] };
      if (Array.isArray(items)) {
        const idx = items.findIndex((i) => i?.id === item.id);
        if (idx >= 0) {
          items[idx] = { ...items[idx], assignedTo: [...assignedTo] };
          items = items;
        }
      }
      return next;
    } catch (err) {
      console.warn("refreshAssignedToFromServer", err);
      return item;
    }
  }

  /** Match an existing chat after Fluent/Merus fetch (phone, email, or linked matter/case). */
  function findConversationForFetchedContact() {
    if (!Array.isArray(items) || !items.length) return null;
    const phoneIntl = phone ? convertToInternational(phone) : "";
    const emailNorm = String(email || "").trim().toLowerCase();
    const matter = String(matterId || "").trim();
    const caseId = String(casefileId || "").trim();

    return (
      items.find((item) => {
        if (!item) return false;
        if (phoneIntl && item.phone && convertToInternational(item.phone) === phoneIntl) {
          return true;
        }
        if (emailNorm && String(item.email || "").trim().toLowerCase() === emailNorm) {
          return true;
        }
        if (matter && Array.isArray(item.fluentCaseMattersIds) && item.fluentCaseMattersIds.map(String).includes(matter)) {
          return true;
        }
        if (
          caseId &&
          Array.isArray(item.advanced?.caseFileIds) &&
          item.advanced.caseFileIds.map(String).includes(caseId)
        ) {
          return true;
        }
        return false;
      }) || null
    );
  }

  function collectStaffEmailsFromAjaxPayload(res) {
    if (!res || typeof res !== "object") return [];
    return STAFF_EMAIL_FIELDS.map((k) => String(res[k] || "").trim().toLowerCase()).filter(Boolean);
  }

  function currentUserStaffIds() {
    return new Set(
      [user?.id, user?.appId, appId]
        .map((id) => (id != null && id !== "" ? String(id) : ""))
        .filter(Boolean)
    );
  }

  /**
   * @param {string[]} emails
   * @param {{ mode?: 'replace' | 'merge' }} [opts]
   * - replace: UI defaults = casefile/matter team matches (excludes logged-in user; they can Add Staff)
   * - merge: union with current assignedStaffIds
   */
  function applySourceStaffEmails(emails, { mode = 'replace' } = {}) {
    const emailSet = new Set(
      (emails || []).map((e) => String(e || "").trim().toLowerCase()).filter(Boolean)
    );
    const teamEmailSet = new Set(
      teamFriends
        .map((f) => String(f?.email || "").trim().toLowerCase())
        .filter(Boolean)
    );
    const selfIds = currentUserStaffIds();
    let matchedIds = teamFriends
      .filter((friend) => friend?.id && friend?.email && emailSet.has(String(friend.email).trim().toLowerCase()))
      .map((friend) => friend.id);
    // Do not auto-assign the logged-in user from Fluent/Merus — Add Staff / Me is explicit.
    matchedIds = matchedIds.filter((id) => !selfIds.has(String(id)));
    const external = [...emailSet].filter((email) => !teamEmailSet.has(email));

    if (mode === 'merge') {
      assignedStaffIds = [...new Set([...assignedStaffIds, ...matchedIds])];
      externalStaffEmails = [...new Set([...externalStaffEmails, ...external])];
      return;
    }
    assignedStaffIds = [...new Set(matchedIds)];
    externalStaffEmails = external;
  }

  /**
   * Pull staff role emails from linked Merus case files / Fluent matters.
   * If the conversation already has saved assignedTo, keep those exactly (no Non-team Fluent extras).
   * Otherwise default to casefile/matter team matches only (UI until Save).
   */
  async function enrichAssignedStaffFromMatterSources(item, overrides: { caseFileId?: string; matterId?: string } = {}) {
    const keepSavedAssignees = conversationHasSavedAssignedStaff(item);
    if (keepSavedAssignees) {
      // Saved assignedTo only — do not show Fluent Non-team as assigned.
      externalStaffEmails = [];
      return;
    }

    const emails = new Set();
    const caseIds = [];
    if (overrides.caseFileId) caseIds.push(String(overrides.caseFileId));
    if (Array.isArray(item?.advanced?.caseFileIds)) {
      item.advanced.caseFileIds.forEach((id) => {
        if (id) caseIds.push(String(id));
      });
    }
    const matterIds = [];
    if (overrides.matterId) matterIds.push(String(overrides.matterId));
    if (Array.isArray(item?.fluentCaseMattersIds)) {
      item.fluentCaseMattersIds.forEach((id) => {
        if (id) matterIds.push(String(id));
      });
    }

    const uniqueCaseIds = [...new Set(caseIds)].slice(0, 5);
    const uniqueMatterIds = [...new Set(matterIds)].slice(0, 5);
    const enrichGen = assignedStaffEditGen;

    const fetches = [];
    if (merusToken) {
      uniqueCaseIds.forEach((id) => {
        fetches.push(
          (async () => {
            try {
              const body = new URLSearchParams();
              body.append("action", "getCaseFileData");
              body.append("casefileId", id);
              body.append("merusToken", merusToken);
              const req = await fetch("https://qix.cloud/ajax/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: body.toString(),
              });
              if (!req.ok) return;
              const res = await req.json();
              collectStaffEmailsFromAjaxPayload(res).forEach((e) => emails.add(e));
            } catch (err) {
              console.warn("enrich Merus staff", id, err);
            }
          })()
        );
      });
    }
    if (fluentCaseToken) {
      uniqueMatterIds.forEach((id) => {
        fetches.push(
          (async () => {
            try {
              const body = new URLSearchParams();
              body.append("action", "getMatterData");
              body.append("matterId", id);
              body.append("fluentCaseToken", fluentCaseToken);
              const req = await fetch("https://qix.cloud/ajax/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: body.toString(),
              });
              if (!req.ok) return;
              const res = await req.json();
              collectStaffEmailsFromAjaxPayload(res).forEach((e) => emails.add(e));
            } catch (err) {
              console.warn("enrich Fluent staff", id, err);
            }
          })()
        );
      });
    }

    if (!fetches.length) {
      return;
    }

    await Promise.all(fetches);

    // User edited staff while Fluent/Merus was loading — keep their selection.
    if (enrichGen !== assignedStaffEditGen) {
      return;
    }

    // Empty assignedTo: show Fluent/Merus team matches as UI defaults only.
    // Do NOT write to server or mutate selectedChatUser.assignedTo here.
    applySourceStaffEmails([...emails], { mode: 'replace' });
  }

  async function persistAssignStaff(chatId, to) {
    const jwtToken = localStorage.getItem("token");
    if (!chatId || !to || !jwtToken) return;
    const res = await fetch("https://api.qix.cloud/assignChat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwtToken,
      },
      body: JSON.stringify({ chat: chatId, to }),
    });
    if (!res.ok) {
      throw new Error("Failed to assign staff");
    }
  }

  async function persistUnassignStaff(chatId, userId) {
    const jwtToken = localStorage.getItem("token");
    if (!chatId || !userId || !jwtToken) return;
    const res = await fetch("https://api.qix.cloud/assignChat", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwtToken,
      },
      body: JSON.stringify({ chat: chatId, user: userId }),
    });
    if (!res.ok) {
      throw new Error("Failed to unassign staff");
    }
  }

  function getFetchedStaffEmails() {
    return [
      attorney_responsible,
      attorney_handling,
      paralegal_handling,
      secretary_handling,
      senior_associate_handling,
      hearing_rep,
      attorney_4,
      staff_4,
    ]
      .map((e) => String(e || "").trim().toLowerCase())
      .filter(Boolean);
  }

  function syncAssignedStaffFromFetch() {
    // Prefer list copy (updated on Save via patchChatAssignedToInList / itemUpdated).
    const existing = findConversationForFetchedContact();
    if (existing && conversationHasSavedAssignedStaff(existing)) {
      loadAssignedStaffFromConversation(existing);
      externalStaffEmails = [];
      return;
    }
    applySourceStaffEmails(getFetchedStaffEmails(), { mode: 'replace' });
    initialAssignedStaffIds = [];
  }

  /** After Fluent/Merus fetch: refresh assignedTo from server/list so Save→Fetch shows saved staff. */
  async function syncAssignedStaffFromFetchAsync() {
    let existing = findConversationForFetchedContact();
    if (existing?.id) {
      existing = await refreshAssignedToFromServer(existing);
      if (Array.isArray(existing?.assignedTo)) {
        patchChatAssignedToInList(existing.id, existing.assignedTo);
      }
    }
    if (existing && conversationHasSavedAssignedStaff(existing)) {
      loadAssignedStaffFromConversation(existing);
      externalStaffEmails = [];
      return;
    }
    applySourceStaffEmails(getFetchedStaffEmails(), { mode: 'replace' });
    initialAssignedStaffIds = [];
  }

  async function addAssignedStaff(friendId) {
    if (!friendId || String(friendId).startsWith("ext:")) return;
    if (assignedStaffIds.includes(friendId)) return;
    assignedStaffEditGen += 1;
    assignedStaffIds = [...assignedStaffIds, friendId];
  }

  async function removeAssignedStaff(friendId) {
    if (!friendId) return;
    assignedStaffEditGen += 1;
    if (String(friendId).startsWith("ext:")) {
      const email = String(friendId).slice(4).toLowerCase();
      externalStaffEmails = externalStaffEmails.filter((e) => e !== email);
      return;
    }
    assignedStaffIds = assignedStaffIds.filter((id) => id !== friendId);
  }

  function staffLabel(friend) {
    const label = friend?.email || friend?.name || friend?.id || "Staff";
    return label.length > 12 ? `${label.slice(0, 9)}...` : label;
  }

  const ASSIGN_REQUEST_DELAY_MS = 350;

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function assignSelectedStaffToChat(chatId, jwtToken, alreadyAssigned: string[] = []) {
    if (!chatId || !jwtToken || assignedStaffIds.length === 0) return;
    const existing = new Set((alreadyAssigned || []).filter(Boolean));
    const toAssign = assignedStaffIds.filter((id) => !existing.has(id));
    // Sequential + delay — assignChat uses read-modify-write and races if parallel
    for (let i = 0; i < toAssign.length; i++) {
      if (i > 0) await delay(ASSIGN_REQUEST_DELAY_MS);
      await persistAssignStaff(chatId, toAssign[i]);
    }
  }

  /** Keep Selectbox + parent chatUsers list in sync after Save (Fluent fetch reuses this list). */
  function patchChatAssignedToInList(chatId, assignedTo) {
    if (!chatId) return;
    const saved = [...new Set((assignedTo || []).filter(Boolean).map(String))];
    let patchedItem = null;
    if (Array.isArray(items)) {
      const idx = items.findIndex((i) => i?.id === chatId);
      if (idx >= 0) {
        patchedItem = { ...items[idx], assignedTo: saved };
        const next = items.slice();
        next[idx] = patchedItem;
        items = next;
      }
    }
    if (selectedChatUser?.id === chatId) {
      selectedChatUser = { ...selectedChatUser, assignedTo: saved };
    }
    if (selectedItem?.id === chatId) {
      selectedItem = { ...selectedItem, assignedTo: saved };
    }
    dispatch("itemUpdated", {
      item: patchedItem || { id: chatId, assignedTo: saved },
    });
  }

  async function syncAssignedStaffChanges(chatId) {
    if (!chatId) return;
    const desired = [
      ...new Set(assignedStaffIds.filter((id) => id && !String(id).startsWith("ext:")).map(String)),
    ];
    // Re-read server assignedTo so we remove extras (e.g. logged-in user added by a race/stale default).
    let serverIds: string[] = [...initialAssignedStaffIds.map(String)];
    try {
      const refreshed = await refreshAssignedToFromServer({ id: chatId, assignedTo: serverIds });
      if (Array.isArray(refreshed?.assignedTo)) {
        serverIds = refreshed.assignedTo.map(String).filter(Boolean);
      }
    } catch (_) {
      /* use initial baseline */
    }
    const desiredSet = new Set(desired);
    const serverSet = new Set(serverIds);
    const toAdd = desired.filter((id) => !serverSet.has(id));
    const toRemove = serverIds.filter((id) => !desiredSet.has(id));
    // Sequential + delay: unassign first, then assign — avoids lost updates on RMW API
    for (let i = 0; i < toRemove.length; i++) {
      if (i > 0) await delay(ASSIGN_REQUEST_DELAY_MS);
      await persistUnassignStaff(chatId, toRemove[i]);
    }
    if (toRemove.length && toAdd.length) {
      await delay(ASSIGN_REQUEST_DELAY_MS);
    }
    for (let i = 0; i < toAdd.length; i++) {
      if (i > 0) await delay(ASSIGN_REQUEST_DELAY_MS);
      await persistAssignStaff(chatId, toAdd[i]);
    }
    assignedStaffIds = [...desired];
    initialAssignedStaffIds = [...desired];
    externalStaffEmails = [];
    patchChatAssignedToInList(chatId, desired);
  }

  /** Unlock share/signature UI after assigning staff */
  async function saveAssignedStaffAndContinue() {
    if (newPanel) {
      if (!String(email || "").trim()) {
        emailFieldError = "Insert email to continue";
        showSaveIndicator("Insert email to continue", "error");
        return;
      }
      emailFieldError = "";
      await addNewUser();
      return;
    }
    if (!selectedChatUser?.id) return;
    isSaving = true;
    staffAssignSaving = true;
    try {
      await syncAssignedStaffChanges(selectedChatUser.id);
      awaitingSaveToContinue = false;
      fetchPromptSource = "";
      showSaveIndicator("Assigned staff saved. Continue signature flow.");
    } catch (e) {
      showSaveIndicator("Failed to save assigned staff", "error");
    } finally {
      isSaving = false;
      staffAssignSaving = false;
    }
  }

  function resetContactFormFields() {
    name = "";
    email = "";
    phone = "";
    casefileId = "";
    matterId = "";
    attorney_responsible = "";
    attorney_handling = "";
    paralegal_handling = "";
    secretary_handling = "";
    senior_associate_handling = "";
    hearing_rep = "";
    attorney_4 = "";
    staff_4 = "";
    assignedStaffIds = [];
    initialAssignedStaffIds = [];
    externalStaffEmails = [];
  }

  function selectAddPanel(e, NewEmail = "") {
    casefileId = "";
    // matterId = "";
    name = "";
    email = NewEmail;
    phone = "";
    assignedStaffIds = [];
    initialAssignedStaffIds = [];
    externalStaffEmails = [];
    awaitingSaveToContinue = false;
    fetchPromptSource = "";
    emailFieldError = "";

    if (e == "new") {
      merusPanel = false;
      fluentCasePanel = false;
      newPanel = true;
      awaitingSaveToContinue = true;
      fetchPromptSource = "new";
    }
    if (e == "merus") {
      newPanel = false;
      fluentCasePanel = false;
      merusPanel = true;
    }
    if (e == "fluentcase") {
      newPanel = false;
      fluentCasePanel = true;
    }
  }

  function clearSelectedContact() {
    selectedChatUser = null;
    searchKey = "";
    selectedItem = null;
    casefileId = "";
    matterId = "";
    displayDropdown = false;
    assignedStaffIds = [];
    initialAssignedStaffIds = [];
    externalStaffEmails = [];
    awaitingSaveToContinue = false;
    fetchPromptSource = "";
  }
  function extractCaseFileId(url) {
    const match = url.match(/\/caseFiles\/view\/(\d+)/);
    return match ? match[1] : null;
  }

  function extractMatterId(url) {
    const match = url.match(/\/matters\/(\d+)/);
    return match ? match[1] : null;
  }

  async function fetchFluentCaseData() {
    isSaving = true;
    try {
      if (matterLink != "") {
        matterId = extractMatterId(matterLink);
        if (matterId != "" && fluentCaseToken != "") {
          let checkMatterId = true;
          let body = new URLSearchParams();
          body.append("action", "getMatterData");
          body.append("matterId", matterId);
          body.append("fluentCaseToken", fluentCaseToken);
          const req = await fetch("https://qix.cloud/ajax/", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: body.toString(),
          });
          const res = await req.json();
          name = res.name;
          email = res.email;
          phone = res.phone;
          attorney_responsible = res.attorney_responsible;
          attorney_handling = res.attorney_handling;
          paralegal_handling = res.paralegal_handling;
          secretary_handling = res.secretary_handling;
          senior_associate_handling = res.senior_associate_handling;
          hearing_rep = res.hearing_rep;
          attorney_4 = res.attorney_4;
          staff_4 = res.staff_4;
          fluentCasePanel = false;
          newPanel = true;
          awaitingSaveToContinue = true;
          fetchPromptSource = "fluent";
          await syncAssignedStaffFromFetchAsync();
          showSaveIndicator("FluentCase data loaded. Click Save to Continue to proceed with the signature.");
        }
      }
    } catch (error) {
      showSaveIndicator("Failed to fetch FluentCase data", "error");
    } finally {
      isSaving = false;
    }
  }

  async function fetchMeruscaesData() {
    isSaving = true;
    try {
      if (casefileLink != "") {
        casefileId = extractCaseFileId(casefileLink);
        if (casefileId != "" && merusToken != "") {
          let checkCasefileId = true;
          items.forEach((item, index) => {
            if (item.advanced.caseFileIds.length > 0) {
              let caseFileIds = item.advanced.caseFileIds;
              caseFileIds.forEach((caseId, idx) => {
                if (caseId == casefileId) {
                  checkCasefileId = false;
                }
              });
              if (!checkCasefileId) {
                //onSelect(item);
                //return;
              }
            }
          });
          let body = new URLSearchParams();
          body.append("action", "getCaseFileData");
          body.append("casefileId", casefileId);
          body.append("merusToken", merusToken);
          const req = await fetch("https://qix.cloud/ajax/", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: body.toString(),
          });
          const res = await req.json();
          name = res.name;
          email = res.email;
          phone = res.phone;
          attorney_responsible = res.attorney_responsible;
          attorney_handling = res.attorney_handling;
          paralegal_handling = res.paralegal_handling;
          secretary_handling = res.secretary_handling;
          senior_associate_handling = res.senior_associate_handling;
          hearing_rep = res.hearing_rep;
          attorney_4 = res.attorney_4;
          staff_4 = res.staff_4;
          merusPanel = false;
          newPanel = true;
          awaitingSaveToContinue = true;
          fetchPromptSource = "merus";
          await syncAssignedStaffFromFetchAsync();
          showSaveIndicator("MerusCase data loaded. Click Save to Continue to proceed with the signature.");
        }
      }
    } catch (error) {
      showSaveIndicator("Failed to fetch MerusCase data", "error");
    } finally {
      // Always reset isSaving, even if an error occurs
      isSaving = false;
    }
  }
  function convertToInternational(phoneNumber) {
    const cleaned = phoneNumber.replace(/\D/g, ""); // Remove non-numeric characters
    if (cleaned.length > 10) {
      return `+${cleaned}`;
    } else {
      return `+1${cleaned}`;
    }
  }

  async function submitMatterId() {
    isSaving = true;
    try {
      const jwtToken = localStorage.getItem("token");
      console.log("item before", selectedItem);
      if (matterId !== "") {

        if (!selectedItem.fluentCaseMattersIds) {
          selectedItem.fluentCaseMattersIds = [];
        }
        selectedItem.fluentCaseMattersIds.push(matterId);
      }

      if (jwtToken != null) {
        await fetch("https://api.qix.cloud/conversation", {
          method: "PUT",
          body: JSON.stringify(selectedItem),
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwtToken,
          },
        });
        addEmailPanel = false;
        onSelect(selectedItem);
        showSaveIndicator("FluentCase data saved successfully!");
      }
      console.log("item after", selectedItem);
      fluentCasePanel = false;
      newPanel = false;
    } catch (error) {
      showSaveIndicator("Failed to save matter ID", "error");
    } finally {
      isSaving = false;
    }
  }

  async function updateExistUser(item) {
    const jwtToken = localStorage.getItem("token");

    item.fullName = name;
    item.email = email;
    item.phone = convertToInternational(phone);
    if (casefileId != "") {
      if (!item.advanced.caseFileIds.includes(casefileId)) {
        item.advanced.caseFileIds.push(casefileId);
      }
    }
    if (matterId !== "") {
        if (!item.fluentCaseMattersIds) {
            item.fluentCaseMattersIds = [];
        }
        if (!item.fluentCaseMattersIds.includes(matterId)) {
          item.fluentCaseMattersIds.push(matterId);
        }
    }
        
    if (jwtToken != null) {
      await fetch("https://api.qix.cloud/conversation", {
        method: "PUT",
        body: JSON.stringify(item),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + jwtToken,
        },
      });
      addEmailPanel = false;

      await syncAssignedStaffChanges(item.id);
      item.assignedTo = [...assignedStaffIds];
      awaitingSaveToContinue = false;
      fetchPromptSource = "";
      onSelect(item, { requireSaveContinue: false });
      showSaveIndicator("Contact and assigned staff saved. Continue signature flow.");
    }
  }
  async function addNewUser() {
    isSaving = true;
    try {
      if (!String(email || "").trim()) {
        emailFieldError = "Insert email to continue";
        showSaveIndicator("Insert email to continue", "error");
        return;
      }
      emailFieldError = "";
      if (name != "" && email != "" && phone != "") {
        let cItem = "";
        items.forEach((item, index) => {
          if (
            convertToInternational(phone) == item.phone ||
            email == item.email
          ) {
            console.log("item", item);
            cItem = item;
          }
        });
        if (cItem != "") {
          initialAssignedStaffIds = Array.isArray(cItem.assignedTo)
            ? [...cItem.assignedTo]
            : [];
          newPanel = false;
          await updateExistUser(cItem);
          return;
        }
        const jwtToken = localStorage.getItem("token");
        if (jwtToken != null) {
          const phoneIntl = convertToInternational(phone);
          const query = new URLSearchParams({
            phone: phoneIntl,
            email: email || "",
          }).toString();

          const res = await fetch(
            `https://api.qix.cloud/conversation?${query}`,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + jwtToken,
              },
            }
          );
          if (!res.ok) {
            throw new Error("Failed to load/create conversation");
          }
          const conversationData = await res.json();
          conversationData.fullName = name;
          conversationData.email = email;
          conversationData.phone = phoneIntl;
          if (!conversationData.advanced) {
            conversationData.advanced = { caseFileIds: [] };
          }
          if (!Array.isArray(conversationData.advanced.caseFileIds)) {
            conversationData.advanced.caseFileIds = [];
          }
          if (casefileId != "") {
            if (!conversationData.advanced.caseFileIds.includes(casefileId)) {
              conversationData.advanced.caseFileIds.push(casefileId);
            }
          }
          if (matterId !== "") {
              if (!conversationData.fluentCaseMattersIds) {
                  conversationData.fluentCaseMattersIds = [];
              }
              if (!conversationData.fluentCaseMattersIds.includes(matterId)) {
                conversationData.fluentCaseMattersIds.push(matterId);
              }
          }
          console.log("conversationData", conversationData);
          const updateResponse = await fetch(
            "https://api.qix.cloud/conversation",
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + jwtToken,
              },
              body: JSON.stringify(conversationData),
            }
          );

          // Preserve existing assignees as baseline, then apply selected staff
          initialAssignedStaffIds = Array.isArray(conversationData.assignedTo)
            ? [...conversationData.assignedTo]
            : [];
          await syncAssignedStaffChanges(conversationData.id);
          conversationData.assignedTo = [...assignedStaffIds];

          if (!updateResponse.ok)
            throw new Error("Failed to update conversation data");

          const updateResult = await updateResponse.json();
          if (updateResult === "success") {
            // Close create panel first, then select so Assign Staff stays visible on the contact
            newPanel = false;
            awaitingSaveToContinue = false;
            fetchPromptSource = "";
            emailFieldError = "";
            name = "";
            email = "";
            phone = "";
            casefileId = "";
            matterId = "";
            attorney_responsible = "";
            attorney_handling = "";
            paralegal_handling = "";
            secretary_handling = "";
            senior_associate_handling = "";
            hearing_rep = "";
            attorney_4 = "";
            staff_4 = "";
            onSelect(conversationData, { requireSaveContinue: false });
            showSaveIndicator("Contact and assigned staff saved. Continue signature flow.");
            dispatch("itemAdded", { item: conversationData });
          }
        }
      } else if (!String(name || "").trim() || !String(phone || "").trim()) {
        showSaveIndicator("Name, email, and phone are required to continue", "error");
      }
    } catch (error) {
      showSaveIndicator("Failed to save new contact", "error");
    } finally {
      isSaving = false;
    }
  }
  onMount(render);
</script>

<div class="select-menu-wrap" style="min-width: min(300px, 100%); width: 100%; max-width: 100%;">
  {#if saveIndicator.show}
    <div class="save-indicator {saveIndicator.type}">
      <div class="save-indicator-content">
        <span class="save-indicator-icon">{saveIndicator.type === 'success' ? '✓' : '✕'}</span>
        <span class="save-indicator-message">{saveIndicator.message}</span>
      </div>
    </div>
  {/if}
  {#if addEmailPanel}
    <div>no email available</div>
    <input
      placeholder="Add Email"
      type="text"
      class="flex-grow bg-transparent py-1 px-2 w-full"
      style="border: 1px solid;border-radius: 5px;margin-bottom: 5px;"
      bind:value={newEmail}
    />
    <button
      class="w-20 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
      on:click={() => updateSelectedUser()}>Update</button
    >
  {:else if showCaseFileSelection || showMatterSelection}
    <!-- ID Selection Panel -->
    <div class="id-selection-panel">
      <p class="selection-title">
        {pendingItem && pendingItem.fullName ? pendingItem.fullName : "User"} has multiple {showCaseFileSelection ? "case files" : "matters"}
      </p>
      
      {#if isLoadingNames}
        <div class="loading-container">
          <p>Loading...</p>
          <img alt="" src="/loading.gif" style="max-width: 30px;" />
        </div>
      {:else}
        {#if showCaseFileSelection && pendingItem && pendingItem.advanced && pendingItem.advanced.caseFileIds && casefileNames.length > 0}
          <div class="selection-group">
            <label for="caseFileSelect" class="selection-label">Select Case File:</label>
            <select 
              id="caseFileSelect"
              bind:value={selectedCaseFileId}
              class="id-select"
            >
              {#each getUniqueCasefiles(casefileNames) as casefile}
                <option value={casefile.id} title="{casefile.name || 'Unnamed'}">
                  {#if casefile.name && casefile.name.length > 40}
                    {casefile.name.substring(0, 37)}... (ID: {casefile.id})
                  {:else}
                    {casefile.name || 'Unnamed'} (ID: {casefile.id})
                  {/if}
                </option>
              {/each}
            </select>
          </div>
        {/if}
        
        {#if showMatterSelection && pendingItem && pendingItem.fluentCaseMattersIds && matterNames.length > 0}
          <div class="selection-group">
            <label for="matterSelect" class="selection-label">Select Matter:</label>
            <select 
              id="matterSelect"
              bind:value={selectedMatterId}
              class="id-select"
            >
              {#each getUniqueMatters(matterNames) as matter}
                <option value={matter.id} title="{matter.name || 'Unnamed'}">
                  {#if matter.name && matter.name.length > 40}
                    {matter.name.substring(0, 37)}... (ID: {matter.id})
                  {:else}
                    {matter.name || 'Unnamed'} (ID: {matter.id})
                  {/if}
                </option>
              {/each}
            </select>
          </div>
        {/if}
        
        <div class="selection-actions">
          <button
            class="cancel-btn"
            on:click={cancelIdSelection}
          >
            Cancel
          </button>
          <button
            class="confirm-btn"
            on:click={confirmIdSelection}
          >
            Continue
          </button>
        </div>
      {/if}
    </div>
  {:else}
    {#if type == "email"}
    <div>
      <p style="color: gray; font-size: 0.9rem; font-weight: bold;">
      Send via Email and get everything automatically in the client's case file.
      </p>
    </div>
      {#if merusCaseEnabled && casefileId == "" && selectedChatUser && (selectedChatUser.advanced.caseFileIds == undefined || selectedChatUser.advanced.caseFileIds.length == 0)}
        <div>
          <p class="selectbox-warning" style="color: red; font-size: 0.85rem; font-weight: bold; line-height: 1.35; white-space: normal; word-break: break-word; margin: 6px 0;">
            Warning: No casefile ID is added
          </p>
        </div>
      {/if}
    {/if}
    {#if type == "sms"}
    <div>
      <p style="color: gray; font-size: 0.9rem; font-weight: bold; line-height: 1.35; white-space: normal;">
        Send an SMS to the client and get the completed document automatically in the case file.
      </p>
    </div>
      {#if merusCaseEnabled && casefileId == "" && selectedChatUser && (selectedChatUser.advanced.caseFileIds == undefined || selectedChatUser.advanced.caseFileIds.length == 0)}
      <div>
        <p class="selectbox-warning" style="color: red; font-size: 0.85rem; font-weight: bold; line-height: 1.35; white-space: normal; word-break: break-word; margin: 6px 0;">
          Warning: No casefile ID is added
        </p>
      </div>
      {/if}
    {/if}
    {#if !newPanel && !merusPanel && !fluentCasePanel}
    <div style="margin-top: 10px; font-weight: bold;">
      Send to:
    </div>
    {#if selectedChatUser}
      <!-- Contact Card Display -->
      <div class="contact-card">
        <button
          class="contact-card-close"
          on:click={clearSelectedContact}
          aria-label="Clear selection"
        >
          ×
        </button>
        <div class="contact-card-content">
          <div class="contact-name" style="display:block;line-height:1.35;margin:0 0 4px;height:auto;position:static;">
            {selectedChatUser.fullName}
          </div>
          <div class="contact-detail" style="display:block;line-height:1.35;margin:0;height:auto;position:static;">
            {#if type === "email"}
              {selectedChatUser.email}
            {:else}
              {formatPhoneDisplay(selectedChatUser.phone)}
            {/if}
          </div>
          {#if merusCaseEnabled && selectedChatUser.advanced && selectedChatUser.advanced.caseFileIds && selectedChatUser.advanced.caseFileIds.length > 0}
            <div class="contact-casefile" style="display:block;line-height:1.35;margin:4px 0 0;height:auto;position:static;">
              casefile ID: {selectedChatUser.advanced.caseFileIds[0]}
            </div>
          {/if}
        </div>
      </div>
      <AssignStaffEditor
        {assignedStaffMembers}
        {availableStaffToAdd}
        {staffLabel}
        saving={staffAssignSaving || isSaving}
        on:add={(e) => addAssignedStaff(e.detail.id)}
        on:remove={(e) => removeAssignedStaff(e.detail.id)}
      />
      {#if awaitingSaveToContinue}
        <div class="save-continue-prompt" data-testid="save-continue-prompt">
          Review assigned staff, then click <strong>Save to Continue</strong> to proceed with the signature flow.
        </div>
        <div class="flex items-center px-2 py-1" style="gap: 10px;">
          <button
            class="flex items-center g-m-btn cursor-pointer"
            data-testid="save-to-continue-btn"
            on:click={saveAssignedStaffAndContinue}
            disabled={isSaving}
            class:disabled={isSaving}
          >
            {#if isSaving}
              <span class="loading-spinner"></span>
              Saving...
            {:else}
              Save to Continue
            {/if}
          </button>
        </div>
      {/if}
    {:else}
      <!-- Search Input -->
      <div style="margin-top: 10px;">
        <input
          {placeholder}
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          style="border: 1px solid;border-radius: 5px;"
          bind:value={searchKey}
          on:click={displayDropdownFunc}
          use:clickOutside
          on:click_outside={hideDropdownFunc}
          on:blur={onSelectKey}
          on:keyup={initSearchCount}
        />
      </div>
    {/if}
    <div
      class="overflow-y-auto py-1 select-menu"
      class:hidden={!displayDropdown || selectedChatUser}
      style="max-height: 200px; z-index: 1000;"
    >
      {#each items as item}
        {#if type == "email" || type == "case" || type == "sms"}
          {#if item.email != "" || item.fullName != ""}
            {#if searchKey == "" || item.email
                .toLowerCase()
                .includes(searchKey.toLowerCase()) || (item.fullName
                .toLowerCase()
                .includes(searchKey.toLowerCase()) && incrementSearchCount())|| (item.phone
                .toLowerCase()
                .includes(searchKey.toLowerCase()) && incrementSearchCount())}
              <div
                class="select-menu-option rounded p-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                on:click={() => onSelect(item)}
                on:keydown={(e) => e.key === 'Enter' && onSelect(item)}
                role="button"
                tabindex="0"
              >
                <div class="select-menu-option__text">
                  <div class="select-menu-option__name">{item.fullName}</div>
                  <div class="select-menu-option__meta">
                    ({type === "email" ? item.email : formatPhoneDisplay(item.phone)})
                  </div>
                  {#if merusCaseEnabled}
                    <div class="select-menu-option__meta">
                      {item.advanced.caseFileIds.length > 0
                        ? item.advanced.caseFileIds.join(", ")
                        : 'No Case File ID'}
                    </div>
                  {/if}
                  {#if fluentCaseEnabled}
                    <div class="select-menu-option__meta">
                      {item.fluentCaseMattersIds && item.fluentCaseMattersIds.length > 0
                        ? item.fluentCaseMattersIds.join(", ")
                        : 'No Matter ID'}
                    </div>
                  {/if}
                </div>
                {#if item.language}
                  <img
                    class="select-menu-option__flag"
                    alt=""
                    src="/flags/{item.language}.png"
                  />
                {/if}
              </div>
            {/if}
          {/if}
        {:else if searchKey == "" || item.fullName
            .toLowerCase()
            .includes(searchKey.toLowerCase())|| item.phone
            .toLowerCase()
            .includes(searchKey.toLowerCase())}
          <div
            class="select-menu-option rounded p-2 hover:bg-gray-100 dark:hover:bg-gray-600"
            on:click={() => onSelect(item)}
            on:keydown={(e) => e.key === 'Enter' && onSelect(item)}
            role="button"
            tabindex="0"
          >
            <div class="select-menu-option__text">
              <div class="select-menu-option__name">{item.fullName}</div>
              <div class="select-menu-option__meta">{formatPhoneDisplay(item.phone)}</div>
            </div>
          </div>
        {/if}
      {/each}
      {#if searchCount < 1 && searchKey}
        <div 
          class="color: #4299e1; flex items-center rounded p-2 hover:bg-gray-100 dark:hover:bg-gray-600" 
          on:click={() => selectAddPanel("new", searchKey)}
          on:keydown={(e) => e.key === 'Enter' && selectAddPanel("new", searchKey)}
          role="button"
          tabindex="0"
        >
            + Add New "{searchKey}"
        </div>
      {/if}
    </div>
    {/if}
        {#if type == "sms" || type == "email"}
    <!-- {#if searchCount < 1 && searchKey} -->
      {#if !newPanel && !merusPanel && !fluentCasePanel && !awaitingSaveToContinue}
      <div class="px-2 py-1 share-email-actions">
        <!-- Buttons in One Line -->
        <div class="flex items-center share-email-actions__row" data-testid="share-email-actions">

          {#if user !== undefined
            ? merusCaseEnabled
            : false}
          <button
            class="flex items-center g-m-btn cursor-pointer"
            on:click={() => selectAddPanel("merus")}
            data-testid="share-merus-button"
          >
            <img alt="" src="meruscase.png" />
            Merus
          </button>
          {/if}
          {#if user !== undefined
            ? fluentCaseEnabled
            : false}
          <button
            class="flex items-center g-m-btn cursor-pointer"
            on:click={() => selectAddPanel("fluentcase")}
            data-testid="share-fluentcase-button"
          >
            <img alt="" src="fluentcase.svg" />
            FluentCase
          </button>
          {/if}

          <button
            class="flex items-center g-m-btn cursor-pointer"
            on:click={() => selectAddPanel("new")}
            data-testid="share-add-new-button"
          >
            <img alt="" src="add.svg" />
            Add New
          </button>
        </div>
    
      </div>
      {/if}
      {#if merusPanel}
        <div class="flex items-center px-2 py-1">
          <input
            placeholder="Insert Meruscase Link"
            type="text"
            class="flex-grow bg-transparent py-1 px-2 w-full"
            style="border: 1px solid;border-radius: 5px;margin-bottom: 5px;"
            bind:value={casefileLink}
          />
        </div>
        <div
          class="flex items-center justify-center px-2 py-1"
          style="gap: 10px;"
        >
          <button
            class="flex items-center g-m-btn cursor-pointer"
            on:click={() => fetchMeruscaesData()}
            disabled={isSaving}
            class:disabled={isSaving}
          >
            {#if isSaving}
              <span class="loading-spinner"></span>
              Fetching...
            {:else}
              Fetch data
            {/if}
          </button>
        </div>
        {:else if fluentCasePanel}
        <div class="flex items-center px-2 py-1">
          <input
            placeholder="Insert FluentCase Link"
            type="text"
            class="flex-grow bg-transparent py-1 px-2 w-full"
            style="border: 1px solid;border-radius: 5px;margin-bottom: 5px;"
            bind:value={matterLink}
          />
        </div>
        <div
          class="flex items-center justify-center px-2 py-1"
          style="gap: 10px;"
        >
          <button
            class="flex items-center g-m-btn cursor-pointer"
            on:click={() => fetchFluentCaseData()}
            disabled={isSaving}
            class:disabled={isSaving}
          >
            {#if isSaving}
              <span class="loading-spinner"></span>
              Fetching...
            {:else}
              Fetch data
            {/if}
          </button>
        </div>
        {:else if false}
        <div class="flex items-center px-2 py-1">
          <input
            placeholder="Enter Matter Id"
            type="text"
            class="flex-grow bg-transparent py-1 px-2 w-full"
            style="border: 1px solid;border-radius: 5px;margin-bottom: 5px;"
            bind:value={matterId}
          />
        </div>
        <div
          class="flex items-center justify-center px-2 py-1"
          style="gap: 10px;"
        >
          <button
            class="flex items-center g-m-btn cursor-pointer"
            on:click={() => submitMatterId()}
            disabled={isSaving}
            class:disabled={isSaving}
          >
            {#if isSaving}
              <span class="loading-spinner"></span>
              Saving...
            {:else}
              Save Matter Id
            {/if}
          </button>
          
        </div>
      {:else if newPanel}
        <div class="send-to-panel">
          <div class="send-to-label">Send to:</div>
          <div class="flex items-center px-2 py-1 send-to-fields" style="gap: 10px;">
            <input
              placeholder="Insert Name"
              type="text"
              class="flex-grow bg-transparent py-1 px-2 w-full"
              style="border: 1px solid;border-radius: 5px;margin-bottom: 5px;"
              bind:value={name}
            />
            <div class="send-to-field send-to-field--email">
              <input
                placeholder="Insert Email"
                type="text"
                class="flex-grow bg-transparent py-1 px-2 w-full"
                class:send-to-input--error={!!emailFieldError || (type === 'email' && awaitingSaveToContinue && !String(email || '').trim())}
                style="border: 1px solid;border-radius: 5px;margin-bottom: 5px;"
                bind:value={email}
                on:input={() => {
                  if (emailFieldError) emailFieldError = "";
                }}
                aria-invalid={!!emailFieldError}
                aria-describedby="send-to-email-hint"
              />
              {#if emailFieldError}
                <p id="send-to-email-hint" class="send-to-field-hint send-to-field-hint--error" role="alert">
                  {emailFieldError}
                </p>
              {:else if type === 'email' && awaitingSaveToContinue && !String(email || '').trim()}
                <p id="send-to-email-hint" class="send-to-field-hint">
                  Insert email to continue
                </p>
              {/if}
            </div>
            <input
              placeholder="Insert Phone"
              type="text"
              class="flex-grow bg-transparent py-1 px-2 w-full"
              style="border: 1px solid;border-radius: 5px;margin-bottom: 5px;"
              bind:value={phone}
            />
          </div>

          <AssignStaffEditor
            {assignedStaffMembers}
            {availableStaffToAdd}
            {staffLabel}
            saving={isSaving}
            on:add={(e) => addAssignedStaff(e.detail.id)}
            on:remove={(e) => removeAssignedStaff(e.detail.id)}
          />

          {#if awaitingSaveToContinue}
            <div class="save-continue-prompt" data-testid="save-continue-prompt">
              {#if fetchPromptSource === 'merus'}
                MerusCase data is ready. Review assigned staff, then click <strong>Save to Continue</strong> to proceed with the signature flow.
              {:else if fetchPromptSource === 'fluent'}
                FluentCase data is ready. Review assigned staff, then click <strong>Save to Continue</strong> to proceed with the signature flow.
              {:else}
                Review contact and assigned staff, then click <strong>Save to Continue</strong> to proceed with the signature flow.
              {/if}
            </div>
          {/if}

          <div
            class="flex items-center px-2 py-1"
            style="gap: 10px;"
          >
            <button
              class="flex items-center g-m-btn cursor-pointer"
              data-testid="save-to-continue-btn"
              on:click={saveAssignedStaffAndContinue}
              disabled={isSaving}
              class:disabled={isSaving}
            >
              {#if isSaving}
                <span class="loading-spinner"></span>
                Saving...
              {:else}
                Save to Continue
              {/if}
            </button>
          </div>
        </div>
      {/if}
    {/if}
    {#if !newPanel && !merusPanel && !fluentCasePanel && !awaitingSaveToContinue}
    <div style="margin-top: 10px; font-weight: bold;">
      {type === "sms" ? "Message:" : "Subject:"}
    </div>
    <div style="margin-top: 10px;">
      <input
      type="text"
      class="flex-grow bg-transparent py-1 px-2 w-full"
      style="border: 1px solid;border-radius: 5px;"
      bind:value={emailSubject}
      placeholder={type === "sms" ? "Insert Message" : ""}
      />
    </div>
    {#if type === "sms"}
      {#if selectedChatUser}
      <button
        class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
        style="display: flex;align-items: center; margin-top: 10px;;max-height: 35px;"
        on:click={() => {
          const modifiedUser = createModifiedUser(selectedChatUser, casefileId, matterId);
          dispatch("send", { type, emailSubject, emailCC: normalizeEmailCC(), modifiedUser });
        }}
      >
        <img
        alt=""
        src="sms.svg"
        style="width: 25px; margin-right: 15px;max-height: 35px;"
        /> Send</button
      >
      {:else}
      <button
        class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded"
        style="display: flex;align-items: center; margin-top: 10px;; background: grey;max-height: 35px;"
        ><img
        alt=""
        src="sms.svg"
        style="width: 25px; margin-right: 15px;max-height: 35px;"
        /> Send</button
      >
      {/if}
    {/if}
    {#if type == "email" || type == "sms"}
      <div style="margin-top: 10px; font-weight: bold;">
        CC:
      </div>
      <div style="margin-top: 10px;">
        <div class="cc-multiselect-container">
          <!-- Selected CCs display -->
          <div
            class="cc-selected-display"
            on:click={toggleCCDropdown}
            role="button"
            tabindex="0"
            on:keydown={(e) => e.key === 'Enter' && toggleCCDropdown()}
          >
            {#if ccArray.length > 0}
              <div class="cc-tags">
                {#each friends as friend}
                  {#if ccArray.includes(friend.email)}
                    <div class="cc-tag">
                      <span style="flex: 1; word-break: break-all;">{friend.email}</span>
                      <button
                        class="cc-tag-remove"
                        on:click={(e) => {
                          e.stopPropagation();
                          toggleFriendCC(friend.email);
                        }}
                        aria-label="Remove {friend.email}"
                      >
                        ×
                      </button>
                    </div>
                  {/if}
                {/each}
              </div>
              <div class="cc-footer">
                <span class="cc-count">{ccArray.length} selected</span>
                <span class="cc-dropdown-arrow">{ccDropdownOpen ? '▲' : '▼'}</span>
              </div>
            {:else}
              <div class="cc-footer" style="width: 100%;">
                <span class="cc-placeholder">Select Team Members</span>
                <span class="cc-dropdown-arrow">{ccDropdownOpen ? '▲' : '▼'}</span>
              </div>
            {/if}
          </div>

          <!-- Dropdown -->
          {#if ccDropdownOpen}
            <div class="cc-dropdown" use:clickOutside on:click_outside={() => ccDropdownOpen = false}>
              {#each friends as friend}
                <div
                  class="cc-option"
                  class:selected={ccArray.includes(friend.email)}
                  on:click={() => toggleFriendCC(friend.email)}
                  on:keydown={(e) => e.key === 'Enter' && toggleFriendCC(friend.email)}
                  role="option"
                  tabindex="0"
                  aria-selected={ccArray.includes(friend.email)}
                >
                  <span class="cc-checkbox">
                    {#if ccArray.includes(friend.email)}
                      ✓
                    {/if}
                  </span>
                  <span class="cc-option-text">{friend.email}</span>
                </div>
              {/each}
              {#if friends.length === 0}
                <div class="cc-no-options">No team members available</div>
              {/if}
            </div>
          {/if}
        </div>
      </div>
      {#if type === "email"}
        {#if checkIfEmailExternal}
          <button
            class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
            style="display: flex;align-items: center; margin-top: 10px;max-height: 35px;"
            on:click={() => {
              const modifiedUser = createModifiedUser(selectedChatUser, casefileId, matterId);
              dispatch("send", { type, emailSubject, emailCC: normalizeEmailCC(), modifiedUser });
            }}
          >
            <img
              alt=""
              src="mail_w.png"
              style="width: 25px; margin-right: 15px;max-height: 35px;"
            /> Send</button
          >
        {:else}
          <button
            class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded"
            style="display: flex;align-items: center; margin-top: 10px; background: grey;max-height: 35px;"
            ><img
              alt=""
              src="mail_w.png"
              style="width: 25px; margin-right: 15px;max-height: 35px;"
            /> Send</button
          >
        {/if}
      {/if}
    {/if}
    {/if}

  {/if}
</div>

<style>
  .select-menu-wrap {
    position: relative;
  }
  .select-menu > div {
    cursor: pointer;
  }
  .select-menu {
    max-height: 12rem;
    position: absolute;
    background: #fff;
    min-width: 100%;
    z-index: 1000;
  }

  .select-menu-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
    min-height: 0;
    height: auto;
  }

  .select-menu-option__text {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .select-menu-option__name,
  .select-menu-option__meta {
    position: static;
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    height: auto;
    line-height: 1.35;
    white-space: normal;
    word-break: break-word;
    overflow: visible;
  }

  .select-menu-option__name {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
  }

  .select-menu-option__meta {
    font-size: 13px;
    font-weight: 400;
    color: #6b7280;
  }

  .select-menu-option__flag {
    width: 20px;
    height: 14px;
    flex-shrink: 0;
    object-fit: cover;
  }

  /* ID Selection Panel Styles */
  .id-selection-panel {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    text-align: center;
    min-width: 0;
    width: 100%;
    max-width: 500px;
  }

  @media (min-width: 768px) {
    .id-selection-panel {
      min-width: 400px;
    }
  }

  .selection-title {
    margin: 0 0 20px 0;
    font-size: 14px;
    color: #374151;
    font-weight: 500;
  }

  .selection-group {
    margin-bottom: 15px;
  }

  .id-select {
    width: 100%;
    max-width: 100%;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    background: #fff;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  
  .id-select option {
    padding: 8px;
    white-space: normal;
    word-wrap: break-word;
  }

  .id-select:hover {
    border-color: #9ca3af;
  }

  .id-select:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .selection-actions {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 20px;
  }

  .cancel-btn, .confirm-btn {
    padding: 8px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
  }

  .cancel-btn {
    background: #f3f4f6;
    color: #374151;
  }

  .cancel-btn:hover {
    background: #e5e7eb;
  }

  .confirm-btn {
    background: #3b82f6;
    color: #fff;
  }

  .confirm-btn:hover {
    background: #2563eb;
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .loading-container p {
    margin: 0 0 10px 0;
    color: #6b7280;
  }

  .selection-label {
    display: block;
    margin-bottom: 8px;
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    text-align: left;
  }

  /* Multi-select CC styles */
  .cc-multiselect-container {
    position: relative;
    width: 100%;
  }

  .cc-selected-display {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-height: 42px;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 5px;
    background: white;
    cursor: pointer;
    transition: all 0.2s;
    gap: 8px;
  }

  .cc-selected-display:hover {
    border-color: #9ca3af;
  }

  .cc-selected-display:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .cc-tags {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin-bottom: 8px;
  }

  .cc-tag {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #3b82f6;
    color: white;
    padding: 10px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    width: 100%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  .cc-tag-remove {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s;
    flex-shrink: 0;
  }

  .cc-tag-remove:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  .cc-count {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
    white-space: nowrap;
  }

  .cc-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .cc-placeholder {
    color: #9ca3af;
    font-size: 14px;
    flex: 1;
  }

  .cc-dropdown-arrow {
    color: #6b7280;
    font-size: 12px;
    transition: transform 0.2s;
    margin-left: 8px;
  }

  .cc-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #d1d5db;
    border-radius: 5px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
  }

  .cc-option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
    transition: background 0.2s;
  }

  .cc-option:hover {
    background: #f3f4f6;
  }

  .cc-option.selected {
    background: #eff6ff;
  }

  .cc-option:focus {
    outline: none;
    background: #eff6ff;
  }

  .cc-checkbox {
    width: 20px;
    height: 20px;
    border: 2px solid #d1d5db;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: white;
    background: white;
    flex-shrink: 0;
  }

  .cc-option.selected .cc-checkbox {
    background: #3b82f6;
    border-color: #3b82f6;
  }

  .cc-option-text {
    flex: 1;
    font-size: 14px;
    color: #374151;
  }

  .cc-no-options {
    padding: 12px;
    text-align: center;
    color: #9ca3af;
    font-size: 14px;
  }

  .send-to-panel {
    width: 100%;
  }

  .send-to-label,
  .assign-staff-label {
    font-weight: 700;
    font-size: 14px;
    color: #111827;
    padding: 4px 8px 2px;
  }

  .send-to-fields {
    flex-wrap: wrap;
  }

  .send-to-field {
    flex: 1 1 140px;
    min-width: 140px;
    display: flex;
    flex-direction: column;
  }

  .send-to-field--email input {
    width: 100%;
  }

  .send-to-input--error {
    border-color: #dc2626 !important;
    box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.15);
  }

  .send-to-field-hint {
    margin: -2px 2px 8px;
    font-size: 12px;
    line-height: 1.3;
    color: #6b7280;
  }

  .send-to-field-hint--error {
    color: #dc2626;
    font-weight: 600;
  }

  .save-continue-prompt {
    margin: 8px;
    padding: 10px 12px;
    background: #eef6ff;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    color: #1e3a8a;
    font-size: 13px;
    line-height: 1.4;
  }

  /* Contact Card Styles */
  .contact-card {
    position: relative;
    background: #F5F5F5;
    border-radius: 8px;
    padding: 14px 40px 14px 14px;
    margin-top: 10px;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
    overflow: visible;
    height: auto;
    min-height: 0;
  }

  @media (min-width: 768px) {
    .contact-card {
      min-width: 300px;
    }
  }

  .contact-card-close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    color: #000000;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s;
    padding: 0;
    z-index: 1;
  }

  .contact-card-close:hover {
    background: #E0E0E0;
  }

  .contact-card-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    width: 100%;
    min-width: 0;
  }

  .contact-name,
  .contact-detail,
  .contact-phone,
  .contact-casefile {
    position: static;
    display: block;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    min-height: 0;
    height: auto;
    overflow: visible;
    white-space: normal;
    word-break: break-word;
  }

  .contact-name {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.35;
    color: #111827;
  }

  .contact-detail,
  .contact-phone {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.35;
    color: #6b7280;
  }

  .contact-casefile {
    font-size: 12px;
    line-height: 1.35;
    color: #9ca3af;
    font-style: italic;
  }

  /* Save Indicator Styles */
  .save-indicator {
    position: relative;
    background: #10B981;
    color: white;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 12px;
    animation: slideIn 0.3s ease-out, fadeOut 0.3s ease-in 2.7s forwards;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
  }

  .save-indicator.error {
    background: #EF4444;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  }

  .save-indicator-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .save-indicator-icon {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    flex-shrink: 0;
  }

  .save-indicator-message {
    font-size: 14px;
    font-weight: 500;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  /* Loading Spinner Styles */
  .loading-spinner {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #ffffff;
    animation: spin 0.8s linear infinite;
    margin-right: 8px;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* Disabled Button State */
  .g-m-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 12px;
    background: #d1d6f6;
    border-radius: 10px;
    border: none;
    font-size: 14px;
    line-height: 1;
    box-sizing: border-box;
    min-height: 40px;
    height: 40px;
  }

  .g-m-btn img {
    width: 18px;
    height: 18px;
    margin: 0;
    object-fit: contain;
  }

  .g-m-btn.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
</style>
